import { render } from "./IconDelete.vue?vue&type=template&id=010f0779"
import script from "./IconDelete.vue?vue&type=script&lang=ts"
export * from "./IconDelete.vue?vue&type=script&lang=ts"
script.render = render

export default script